import { useEffect, useState } from 'react';
import axios from '../api/axiosInstance';

function useNextReservationInfo(userId) {
  const [nextReservationInfo, setNextReservationInfo] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0); // 👈 nowy trigger
  const HOST = process.env.REACT_APP_HOST;
  const PORT = process.env.REACT_APP_API_PORT;
  const baseUrl = `https://${HOST}`;

  useEffect(() => {
    if (userId !== null) {
      const fetchNextReservationInfo = async () => {
        const token = localStorage.getItem('token');
        const now = new Date();
        const currentHour = now.getHours();
        let targetDate = new Date(now);

        if (currentHour >= 19) {
          targetDate.setDate(targetDate.getDate() + 1);
        }

        while (targetDate.getDay() === 0 || targetDate.getDay() === 6) {
          targetDate.setDate(targetDate.getDate() + 1);
        }

        const dateStr = targetDate.toISOString().split('T')[0];

        try {
          const res = await axios.get(`${baseUrl}/api/user/reservations`);
          const match = res.data.find((r) => r.date === dateStr);
          if (JSON.stringify(nextReservationInfo) !== JSON.stringify(match || null)) {
            setNextReservationInfo(match ? {
              ...match,
              regCarNum: typeof match.regCarNum === 'string'
                ? match.regCarNum.replace(/^["']+|["']+$/g, '')
                : match.regCarNum
            } : null);
          } else {
          }
        } catch (err) {
          setNextReservationInfo(null);
        }
      };

      fetchNextReservationInfo();
    }
  }, [userId, refetchTrigger]); // 👈 TERAZ reagujemy na zmianę triggera

  const refetch = () => {
    setRefetchTrigger(prev => prev + 1); // 🔁 zmienia zależność => odpala useEffect
  };

  return [nextReservationInfo, refetch];
}

export default useNextReservationInfo;